import axios from "axios";

export const viacepService = {
    buscaCep: async (cep) => {
        cep = cep.replace(/\D/g, "");

        const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);

        return response.data;
    }
}